// External Dependencies:
import React from 'react'
import { localize } from 'i18n-calypso'

// Internal Dependencies:
import Share from 'church-theme-library/components/Share/Share'

class ShareLinks extends React.Component {
	render() {
		const { translate, currentlyViewedPage } = this.props
		const page = this.props.pageOverride ? this.props.pageOverride : this.props.page

		if ( ! currentlyViewedPage ) {
			return null
		}

		const url = currentlyViewedPage.url_full
		const title = currentlyViewedPage.title.raw

		return (
			<div className="share-links">
				<div className="-inner">
					<Share type="facebook" url={ url } title={ title }>
						<i className="icon-facebook" aria-hidden="true"></i>
					</Share>

					<Share type="twitter" url={ url } title={ title }>
						<i className="icon-twitter" aria-hidden="true"></i>
					</Share>
				</div>
			</div>
		)
	}
}

export default localize( ShareLinks )
